import React, { useEffect } from "react";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Box,
} from "@material-ui/core";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployees } from "../../../../Redux/actions";
import {
  StyledTableCell,
  StyledTableRow,
  StyledTableExpiry,
  StyledTableJob,
} from "./styles";
import { getEmployeesContract, getFullName } from "../../../../utils/utils";

export default function EmployeeContractTable() {
  let employees = useSelector((state) => state.employees.payload);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!employees || employees.length === 0) {
      dispatch(fetchEmployees());
    }
  }, []);

  if (employees && employees.length > 0) {
    employees = getEmployeesContract(employees);
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell>
              <Box ml="12%">Employee Name</Box>
            </StyledTableCell>
            <StyledTableCell>
              <Box ml="10%">Job Title</Box>
            </StyledTableCell>
            <StyledTableCell>
              <Box textAlign="center">Contract Type</Box>
            </StyledTableCell>
            <StyledTableCell>
              <Box textAlign="center">Days to Expire</Box>
            </StyledTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {employees &&
            employees.map((emp) => (
              <StyledTableRow key={emp._id}>
                <StyledTableCell>
                  <Box display="flex" alignItems="center" ml="12%">
                    <Avatar component="span" alt={emp.name} src={emp?.image} />
                    <Box ml={1}> {getFullName(emp)}</Box>
                  </Box>
                </StyledTableCell>

                <StyledTableCell>
                  <Box
                    width="fit-content"
                    display="flex"
                    alignItems="center"
                    ml="10%"
                  >
                    {emp.job_title}
                  </Box>
                </StyledTableCell>
                <StyledTableCell>
                  <StyledTableJob contractType={emp.contract}>
                    {emp.contract}
                  </StyledTableJob>
                </StyledTableCell>
                <StyledTableCell>
                  <StyledTableExpiry>{emp.daysEnd + " days"}</StyledTableExpiry>
                </StyledTableCell>
              </StyledTableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
